import tippy from 'tippy.js'

import 'tippy.js/dist/tippy.css'
// import 'tippy.js/dist/svg-arrow.css'
// import 'tippy.js/dist/backdrop.css'
// import 'tippy.js/animations/scale.css'
// import 'tippy.js/animations/shift-away.css'

export const ToolType = tooltypeClass => {

  tippy(`.${tooltypeClass}`, {
    theme: 'custom',
    arrow: true,
    // animateFill: true,
    // plugins: [animateFill]
  })
}